var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderByIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_1001)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84473 5C2.84473 4.65482 3.12455 4.375 3.46973 4.375H10.9697C11.3149 4.375 11.5947 4.65482 11.5947 5C11.5947 5.34518 11.3149 5.625 10.9697 5.625H3.46973C3.12455 5.625 2.84473 5.34518 2.84473 5ZM2.84473 10C2.84473 9.65482 3.12455 9.375 3.46973 9.375H9.30306C9.64824 9.375 9.92806 9.65482 9.92806 10C9.92806 10.3452 9.64824 10.625 9.30306 10.625H3.46973C3.12455 10.625 2.84473 10.3452 2.84473 10ZM3.46973 14.375C3.12455 14.375 2.84473 14.6548 2.84473 15C2.84473 15.3452 3.12455 15.625 3.46973 15.625H9.30306C9.64824 15.625 9.92806 15.3452 9.92806 15C9.92806 14.6548 9.64824 14.375 9.30306 14.375H3.46973ZM12.1945 12.0581C12.4385 11.814 12.8343 11.814 13.0783 12.0581L14.5114 13.4911V5C14.5114 4.65482 14.7912 4.375 15.1364 4.375C15.4816 4.375 15.7614 4.65482 15.7614 5V13.4911L17.1945 12.0581C17.4385 11.814 17.8343 11.814 18.0783 12.0581C18.3224 12.3021 18.3224 12.6979 18.0783 12.9419L15.5783 15.4419C15.5184 15.5019 15.4493 15.5471 15.3756 15.5776C15.3036 15.6074 15.2248 15.6242 15.1422 15.625C15.1402 15.625 15.1383 15.625 15.1364 15.625C15.1345 15.625 15.1325 15.625 15.1306 15.625C15.048 15.6242 14.9692 15.6074 14.8972 15.5776C14.8234 15.5471 14.7544 15.5019 14.6945 15.4419L12.1945 12.9419C11.9504 12.6979 11.9504 12.3021 12.1945 12.0581Z",
    fill: "#D7D8E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_1001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.136719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderByIcon);
export default __webpack_public_path__ + "static/media/order-by-icon.197f477f2ec5e89fa49014c81123d363.svg";
export { ForwardRef as ReactComponent };